<template>
  <div class="more-btn-box" id="moreBtnBox9"></div>
</template>
<script>
export default {
  components: {},
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    isMore: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      observer: null,
    };
  },
  created() {},
  mounted() {
    // console.log(this.arrContent, 'arrContent')
    this.observer = new IntersectionObserver(this.handleIntersection, {
      rootMargin: "0px",
      threshold: 1.0,
    });
    // 你可以观察任何你想要的元素
    const element = document.querySelector("#moreBtnBox9");
    if(element) {
      this.observer.observe(element);
    }
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    isElementInViewport(el) {
      const rect = el.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <=
          (window.innerWidth || document.documentElement.clientWidth)
      );
    },
    handleIntersection(entries, observer) {
      entries.forEach((entry) => {
        if (entry.isIntersecting && this.isElementInViewport(entry.target)) {
          // 元素首次出现在可视区域内
          // console.log("Element is in viewport for the first time:", entry.target);
          // observer.unobserve(entry.target); // 停止观察
          if (this.isMore) {
            this.$emit("moreFun");
          } else {
            observer.unobserve(entry.target); // 停止观察
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.more-btn-box {
  width: 100%;
  padding: 10px 0;
  text-align: center;
}
</style>
